import Vue from "vue"
import Vuex from "vuex"

import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import "firebase/functions"

firebase.initializeApp({
	apiKey: "AIzaSyDJ7EZaY1ZpYWhRmf55TFSUsb5Kasrv7GI",
	authDomain: "cast-9c28d.firebaseapp.com",
	databaseURL: "https://cast-9c28d.firebaseio.com",
	projectId: "cast-9c28d",
	storageBucket: "cast-9c28d.appspot.com",
	messagingSenderId: "875607439906"
})

Vue.use(Vuex)

export const store = new Vuex.Store({
	state: {
		firebase,
		user: undefined,
		// pageLoading: window.innerWidth > 1024,
		pageLoading: true,
		isMobile: window.innerWidth <= 1024,
		width: window.innerWidth,
		darkNav: false,
	},
	getters: {
		getDb(state) {
			return state.firebase.firestore
		},
		getAuth(state) {
			return state.firebase.auth
		},
		getFunctions(state) {
			return state.firebase.functions()
		},
		getPageLoading(state) {
			return state.pageLoading
		},
		getMobile(state) {
			return state.isMobile
		},
		getWidth(state) {
			return state.width
		},
		getDarkNav(state) {
			return state.darkNav
		}
	},
	mutations: {
		setPageLoading(state, loading) {
			state.pageLoading = loading// && !state.isMobile
			Vue.nextTick(() => {
				const nav = document.querySelector('nav')
				if(nav) nav.dispatchEvent(new Event('mouseleave'))
			})
		},
		setMobile(state, mobile) {
			state.isMobile = mobile
		},
		setWidth(state, width) {
			state.width = width
		},
		setDarkNav(state, value) {
			state.darkNav = value
		}
	}
})

window.addEventListener('resize', () => {
	store.commit('setMobile', window.innerWidth <= 1024)
	store.commit('setWidth', window.innerWidth)
})
